import { Modal } from 'react-bootstrap'
import { BasicButton } from '../../../widgets/components/UI/BasicButton'
import { Dispatch, SetStateAction } from 'react'

export const DeleteFounderPromoterModal = ({
  setDeleteShowModal,
  showDeleteModal,
  onDeleteSubmit,
  deleteLoading,
  header,
  paragraph,
  isParticipant = false,
  participantHeading
}: {
  setDeleteShowModal: Dispatch<SetStateAction<boolean>>
  showDeleteModal: boolean
  onDeleteSubmit: any
  deleteLoading: boolean
  header: string
  paragraph: string
  isParticipant?: boolean
  participantHeading?: 'present' | 'absent' | null
}) => {

  return (
    <>
      <Modal
        show={showDeleteModal}
        onHide={() => setDeleteShowModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h2>{header}</h2>
        </Modal.Header>
        <Modal.Body className='container'>
          <p>{paragraph}</p>
        </Modal.Body>
        <Modal.Footer>
          {/* <BasicButton
            height='44px'
            border='none'
            color='#F5F8FA'
            textColor='#7E8299'
            padding='12px 16px'
            onClick={() => {
              setDeleteShowModal(false)
            }}
            buttonText='Cancel'
            minWidth={56}
          />

          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              onDeleteSubmit()
            }}
            buttonText={isParticipant && participantHeading ? `Mark as ${participantHeading}` : 'Confirm Delete'}
            minWidth={56}
            loading={deleteLoading}
            disabled={deleteLoading}
          /> */}
          <div className='d-flex flex-md-row flex-column justify-content-md-end gap-2 w-100'>
            <BasicButton
              onClick={() => {
                setDeleteShowModal(false)
              }}
              buttonText='Cancel'
              customClass='w-md-auto w-100 custom-button-property bg-light text-muted order-2 order-md-1'
            />

            <BasicButton
              onClick={() => {
                onDeleteSubmit()
              }}
              buttonText={isParticipant && participantHeading ? `Mark as ${participantHeading}` : 'Confirm Delete'}
              customClass='w-md-auto w-100 custom-button-property bg-primary text-white order-1 order-md-2'
              loading={deleteLoading}
              disabled={deleteLoading}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
